import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CommonTable from '../../common/components/CommonTable';
import CommonLoader from '../../common/components/CommonLoader';
import InvoicesTableRow from './InvoicesTableRow';

const headers = [
  { label: 'ID' },
  { label: 'Invoice Number' },
  { label: 'Amount' },
  { label: 'Creation Date' },
  { label: 'Dealer' },
  { label: 'Organization Location' },
  { label: 'Payment Status' },
  { label: 'Actions' },
];

function InvoicesTable({ data, offset, changeOffset }) {
  const loaderStatus = useSelector((state) => state.invoices.get('loaderStatus'));
  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            rowComponent={InvoicesTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Invoices"
            hasRowPointer={false}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

InvoicesTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default InvoicesTable;
